import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  rentalOfferDraft: {
    productId: null,
    // buyerId: null, // The user to whom the offer is being made, if initiated by merchant
    // merchantId: null, // The merchant making the offer (auto-filled)
    rentalStartDate: null,
    rentalEndDate: null,
    proposedPrice: null,
    message: '', // Optional message from merchant to buyer or vice-versa if we allow counter-offers
    status: 'draft', // e.g., draft, submitted, accepted, rejected, withdrawn
    // relatedOrder: null, // If this offer gets converted to an order
  },
  selectedOffer: null,
  // Potentially lists of offers if not solely relying on API cache
  // myOffers: [],
  // merchantOffers: [],
  loading: false,
  error: null,
};

const offerSlice = createSlice({
  name: 'offer',
  initialState,
  reducers: {
    // Rental Offer Draft reducers
    updateRentalOfferDraft: (state, action) => {
      state.rentalOfferDraft = { ...state.rentalOfferDraft, ...action.payload };
    },
    setRentalOfferProductId: (state, action) => {
      state.rentalOfferDraft.productId = action.payload;
    },
    clearRentalOfferDraft: (state) => {
      state.rentalOfferDraft = initialState.rentalOfferDraft;
    },
    // Selected Offer reducers
    setSelectedOffer: (state, action) => {
      state.selectedOffer = action.payload;
    },
    clearSelectedOffer: (state) => {
      state.selectedOffer = null;
    },
    // Example reducers for API call lifecycle (if not fully handled by RTK Query listeners)
    // submitOfferStart: (state) => {
    //   state.loading = true;
    //   state.error = null;
    // },
    // submitOfferSuccess: (state, action) => {
    //   state.loading = false;
    //   // state.myOffers.push(action.payload); // Or update RTK query cache
    //   state.rentalOfferDraft = initialState.rentalOfferDraft;
    // },
    // submitOfferFailure: (state, action) => {
    //   state.loading = false;
    //   state.error = action.payload;
    // },
  },
  // Extra reducers can be added here to listen to offerApi actions
  // example:
  // extraReducers: (builder) => {
  //   builder
  //     .addMatcher(offerApi.endpoints.submitRentalOffer.matchPending, (state) => {
  //       state.loading = true;
  //       state.error = null;
  //     })
  //     .addMatcher(offerApi.endpoints.submitRentalOffer.matchFulfilled, (state, action) => {
  //       state.loading = false;
  //       // Potentially update local state or rely on cache invalidation
  //       state.rentalOfferDraft = initialState.rentalOfferDraft;
  //     })
  //     .addMatcher(offerApi.endpoints.submitRentalOffer.matchRejected, (state, action) => {
  //       state.loading = false;
  //       state.error = action.payload ? action.payload.error : 'Failed to submit offer';
  //     });
  // }
});

export const {
  updateRentalOfferDraft,
  setRentalOfferProductId,
  clearRentalOfferDraft,
  setSelectedOffer,
  clearSelectedOffer,
  // submitOfferStart,
  // submitOfferSuccess,
  // submitOfferFailure,
} = offerSlice.actions;

export const selectRentalOfferDraft = (state) => state.offer.rentalOfferDraft;
export const selectSelectedOffer = (state) => state.offer.selectedOffer;
export const selectOfferLoading = (state) => state.offer.loading;
export const selectOfferError = (state) => state.offer.error;

export default offerSlice.reducer; 